import { DateItem } from './dates'

export const useVerifyBypass = () => {
	return (
		import.meta.env?.VITE_FEATURE_BYPASS_REG_STEP2 &&
		import.meta.env?.VITE_FEATURE_BYPASS_REG_STEP2 == 'true'
	)
}

export const useVerifyDisable = () => {
	return import.meta.env?.VITE_FEATURE_DISABLE_REG_STEP2 == 'true'
}

export const useHideAuthorizations = (): boolean => {
	const AUTH_DATE_VAR: string | undefined = import.meta.env?.VITE_FEATURE_HIDE_AUTHORIZATIONS as
		string | undefined
	if (!AUTH_DATE_VAR) return false

	const today = new DateItem({}).parsed
	const authDate = new DateItem({ date: AUTH_DATE_VAR }).parsed
	return today >= authDate
}
